<div class="wrapper__headerComponent container my-5">
  <div class="container-example-linea-avance-govco mx-0 my-5">
    <div class="linea-avance-govco ih-linea-avance-govco m-0 p-0" id="lineaAvance3">
      <div class="mb-4">
        <div class="progress" style="width: 100% !important;">
          <progress class="progress-bar" value="15" max="100">
          </progress>
        </div>
        <div class="items-header-linea-avance-govco">
          <div class="header-linea-avance-govco active-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance1" percentage="8"
                    onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(1)"
                    aria-label="Ir a paso 1">
              <span>1</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][0] }}
            </span>
          </div>

          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance2"
                    percentage="20" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(2)"
                    aria-label="Ir a paso 2">
              <span>2</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][17] }}
            </span>
          </div>

          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance3"
                    percentage="20" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(3)"
                    aria-label="Ir a paso 3">
              <span>3</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][1] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance4"
                    percentage="30" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(4)"
                    aria-label="Ir a paso 4">
              <span>4</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][2] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance5"
                    percentage="40" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(5)"
                    aria-label="Ir a paso 5">
              <span>5</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][3] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance6"
                    percentage="50" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(6)"
                    aria-label="Ir a paso 6">
              <span>6</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][4] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance7"
                    percentage="60" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(7)"
                    aria-label="Ir a paso 7">
              <span>7</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][5] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance8"
                    percentage="70" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(8)"
                      aria-label="Ir a paso 8">
              <span>8</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][6] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance9"
                    percentage="80" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(9)"
                    aria-label="Ir a paso 9">
              <span>9</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][7] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance10"
                    percentage="90" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(10)"
                    aria-label="Ir a paso 10">
              <span>10</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][8] }}
            </span>
          </div>
          <!-- <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance10"
              percentage="90" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(10)">
              <span>10</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][12] }}
            </span>
          </div> -->
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance11"
                    percentage="100" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(11)"
                    aria-label="Ir a paso 11">
              <span>11</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][13] }}
            </span>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance1" class="body-linea-avance-govco active-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección inicial -->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][0]"
              [fields]="reorSociedadIdentificacionDeudor"
              (changedControl)="onSubmitSociedadIdentificacionDeudor($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <div class="mt-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_1).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_1)"
                    [paso]="listaPasosRoi.PASO_1"
                    [codigoPretencion]="pretencionesPaso1"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_1)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_1).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_1)"
                    [paso]="listaPasosRoi.PASO_1"
                    [codigoPretencion]="pretencionesPaso1"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_1)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formIdentificacionDeudor, listaPasosRoi.PASO_1, $event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance2" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Agregar profesionales-->
            <!-- Revisor fiscal -->
            <div>
              <app-form
                #FormComponent
                *ngIf="mostrarTipoRevisor"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor']"
                [fields]="campoTipoRevisor"
                (changedControl)="capturarFormTipoRevisor($event)"
                [withSubmitButton]="false"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Revisor fiscal PN -->
              <app-form
                #FormComponent
                *ngIf="mostrarRevisorPN"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal_PN']"
                [fields]="camposRevisorPN"
                (changedControl)="capturarFormRevisorPN($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-revisor']"
                (submitAction)="guardarProfesional(false, 'revisor')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Revisor fiscal PJ -->
              <app-form
                #FormComponent
                *ngIf="mostrarRevisorPJ"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal_PJ']"
                [fields]="camposRevisorPJ"
                (changedControl)="capturarFormRevisorPJ($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-revisor']"
                (submitAction)="guardarProfesional(false, 'revisor')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
                {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal'] }}
              </h4>
              <div class="col-12 d-flex justify-content-end">
                <button
                  type="submit"
                  class="btn-govco fill-add-govco mt-3"
                  (click)="habilitarTipoRevisor()"
                  [disabled]="datosRevisores.length === 5"
                  [attr.aria-label]="roiText['botones-envio']['agregar-revisor']">
                  {{ comunText['agregar-revisor'] }}
                </button>
              </div>
              <app-table
                [columnas]="columnasRevisor"
                [datos]="datosRevisores"
                [acciones]="accionesRevisor"
                (eventoAccion)="eliminarRevisor($event)">
              </app-table>
            </div>
            <!-- Apoderado -->
            <div>
              <app-form
                #FormComponent
                *ngIf="mostrarTipoApoderado"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado']"
                [fields]="campoTipoApoderado"
                (changedControl)="capturarFormTipoApoderado($event)"
                [withSubmitButton]="false"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Apoderado PN -->
              <app-form
                #FormComponent
                *ngIf="mostrarApoderadoPN"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_PN']"
                [fields]="camposApoderadoPN"
                (changedControl)="capturarFormApoderadoPN($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-apoderado']"
                (submitAction)="guardarProfesional(false, 'apoderado')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Apoderado PJ -->
              <app-form
                #FormComponent
                *ngIf="mostrarApoderadoPJ"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_PJ']"
                [fields]="camposApoderadoPJ"
                (changedControl)="capturarFormApoderadoPJ($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-apoderado']"
                (submitAction)="guardarProfesional(false, 'apoderado')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
                {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado'] }}
              </h4>
              <div class="col-12 d-flex justify-content-end">
                <button
                  type="submit"
                  class="btn-govco fill-add-govco mt-3"
                  (click)="habilitarTipoApoderado()"
                  [disabled]="datosApoderados.length === 5"
                  [attr.aria-label]="roiText['botones-envio']['agregar-apoderado']">
                  {{ comunText['agregar-apoderado'] }}
                </button>
              </div>
              <app-table
                [columnas]="columnasApoderado"
                [datos]="datosApoderados"
                [acciones]="accionesApoderado"
                (eventoAccion)="eliminarApoderado($event)">
              </app-table>
            </div>
            <!-- Contador -->
            <div>
              <app-form
                #FormComponent
                *ngIf="mostrarTipoContador"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador']"
                [fields]="campoTipoContador"
                (changedControl)="capturarFormTipoContador($event)"
                [withSubmitButton]="false"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Contador PN -->
              <app-form
                #FormComponent
                *ngIf="mostrarContadorPN"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_PN']"
                [fields]="camposContadorPN"
                (changedControl)="capturarFormContadorPN($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-contador']"
                (submitAction)="guardarProfesional(false, 'contador')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <!-- Contador PJ -->
              <app-form
                #FormComponent
                *ngIf="mostrarContadorPJ"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_PJ']"
                [fields]="camposContadorPJ"
                (changedControl)="capturarFormContadorPJ($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-contador']"
                (submitAction)="guardarProfesional(false, 'contador')"
                [filtrarTiposDocumento] = "true">
              </app-form>
              <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
                {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador'] }}
              </h4>
              <div class="col-12 d-flex justify-content-end">
                <button
                  type="submit"
                  class="btn-govco fill-add-govco mt-3"
                  (click)="habilitarTipoContador()"
                  [disabled]="datosContadores.length === 5"
                  [attr.aria-label]="roiText['botones-envio']['agregar-contador']">
                  {{ comunText['agregar-contador'] }}
                </button>
              </div>
              <app-table
                [columnas]="columnasContador"
                [datos]="datosContadores"
                [acciones]="accionesContador"
                (eventoAccion)="eliminarContador($event)">
              </app-table>
            </div>
            <!-- Representante legal -->
            <div>
              <app-form
                #FormComponent
                *ngIf="mostrarTipoRepresentante"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_representante']"
                [fields]="campoTipoRepresentante"
                (changedControl)="capturarFormTipoRepresentante($event)"
                [withSubmitButton]="false">
              </app-form>
              <!-- Representante legal PN -->
              <app-form
                #FormComponent
                *ngIf="mostrarRepresentantePN"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal_PN']"
                [fields]="camposRepresentantePN"
                (changedControl)="capturarFormRepresentantePN($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-representante']"
                [filtrarTiposDocumento]="true"
                (submitAction)="guardarProfesional(false, 'representante')">
              </app-form>
              <!-- Representante legal PJ -->
              <app-form
                #FormComponent
                *ngIf="mostrarRepresentantePJ"
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal_PJ']"
                [fields]="camposRepresentantePJ"
                (changedControl)="capturarRepresentantePJ($event)"
                [withSubmitButton]="true"
                [sumbitButtonText]="comunText['agregar-representante']"
                (submitAction)="guardarProfesional(false, 'representante')">
              </app-form>
              <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
                {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['representante_legal'] }}
              </h4>
              <div class="col-12 d-flex justify-content-end">
                <button
                  type="submit"
                  class="btn-govco fill-add-govco mt-3"
                  (click)="habilitarTipoRepresentante()"
                  [attr.aria-label]="roiText['botones-envio']['agregar-representante']">
                  {{ comunText['agregar-representante'] }}
                </button>
              </div>
              <app-table
                [columnas]="columnasRepresentante"
                [datos]="datosRepresentantes"
                [acciones]="accionesRepresentante"
                (eventoAccion)="eliminarRepresentante($event)">
              </app-table>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="onSubmitFormulario(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                        (click)="onContinueRevisoresContadores($event)"
                        [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance3" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Información de profesionales asociados al deudor -->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][2]"
              [fields]="reorSociedadInformacionProfesionales"
              (changedControl)="onSubmitSociedadInformacionProfesionales($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <!-- Sección Información de profesionales asociados al deudor -->
            <div class="mt-3" *ngIf="mostrarArchivosPaso2">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_2).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_2)"
                    [paso]="listaPasosRoi.PASO_2"
                    [codigoPretencion]="pretencionesPaso2"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_2)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_2).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_2)"
                    [paso]="listaPasosRoi.PASO_2"
                    [codigoPretencion]="pretencionesPaso2"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_2)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formInformacionProfesionales, listaPasosRoi.PASO_2, $event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance4" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Supuestos de admisibilidad-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][3]"
              [fields]="reorSociedadSupuestosAdmisibilidad"
              (changedControl)="onSubmitSociedadSupuestosAdmisibilidad($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <div class="mt-3" *ngIf="mostrarArchivosPaso3">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <!-- Memoria explicativa de las causas de insolvencia -->
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_3).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_3)"
                    [paso]="listaPasosRoi.PASO_3"
                    [codigoPretencion]="pretencionesPaso3"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_3)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_3).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_3)"
                    [paso]="listaPasosRoi.PASO_3"
                    [solicitante]="solicitante"
                    [codigoPretencion]="pretencionesPaso3"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_3)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <!-- Supuestos de admisibilidad -->
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_4).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_4)"
                    [paso]="listaPasosRoi.PASO_4"
                    [codigoPretencion]="pretencionesPaso3"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_4)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_4).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_4)"
                    [paso]="listaPasosRoi.PASO_4"
                    [codigoPretencion]="pretencionesPaso3"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_4)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinuePasoTres($event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance5" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Relación de Pasivos (Artículo 32, Ley 1429 de 2010)-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][4]"
              [fields]="reorSociedadRelacionPasivos"
              (changedControl)="onSubmitSociedadRelacionPasivos($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <div class="mt-3" *ngIf="mostrarArchivosPaso4">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_5).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_5)"
                    [paso]="listaPasosRoi.PASO_5"
                    [codigoPretencion]="pretencionesPaso4"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_5)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_5).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_5)"
                    [paso]="listaPasosRoi.PASO_5"
                    [codigoPretencion]="pretencionesPaso4"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_5)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formRelacionPasivos, listaPasosRoi.PASO_5, $event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance6" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Información financiera con corte al último día calendario del mes anterior-->
            <app-form [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][5]"
                      [fields]="reorSociedadInformacionFinancieraMes"
                      (changedControl)="onSubmitSociedadInformacionFinancieraMes($event)"
                      [idEntidad]="entidadId"
                      [withSubmitButton]="false">
            </app-form>
            <div class="mt-3" *ngIf="mostrarArchivosPaso5">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_6).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_6)"
                    [paso]="listaPasosRoi.PASO_6"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_6)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_6).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_6)"
                    [paso]="listaPasosRoi.PASO_6"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_6)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formInformacionFinancieraMes, listaPasosRoi.PASO_6, $event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance7" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Información financiera con corte al último año anterior-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][6]"
              [fields]="reorSociedadInformacionFinancieraAnio"
              (changedControl)="onSubmitSociedadInformacionFinancieraAnio($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)" [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinueInfoFinanciera($event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance8" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Conjunto completo de estados financieros comparativos-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][7]"
              [fields]="reorSociedadEstadosFinancieros"
              (changedControl)="onSubmitSociedadEstadosFinancieros($event)"
              [idEntidad]="entidadId" [withSubmitButton]="false">
            </app-form>
            <div class="mt-3" *ngIf="mostrarArchivosPaso7">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_7).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_7)"
                    [paso]="listaPasosRoi.PASO_7"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_7)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_7).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_7)"
                    [paso]="listaPasosRoi.PASO_7"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_7)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formEstadosFinancieros, listaPasosRoi.PASO_7, $event)" 
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance9" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <div class="mt-3" *ngIf="mostrarArchivosPaso8">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_8).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_8)"
                    [paso]="listaPasosRoi.PASO_8"
                    [idTipoTramite]="tipoTramite"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_8)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_8).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_8)"
                    [paso]="listaPasosRoi.PASO_8"
                    [idTipoTramite]="tipoTramite"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_8)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button
                  type="button" class="btn-govco fill-before-btn-govco w-auto"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)"
                  [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                        (click)="onContinueOnlyDocs(listaPasosRoi.PASO_8, $event)" 
                        [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance10" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Otros documentos requeridos-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][9]"
              [fields]="reorSociedadOtrosDocumentos"
              (changedControl)="onSubmitSociedadOtrosDocumentos($event)"
              [idEntidad]="entidadId"
              [withSubmitButton]="false">
            </app-form>
            <div class="mt-3" *ngIf="mostrarArchivosPaso9">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_9).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_9)"
                    [paso]="listaPasosRoi.PASO_9"
                    [codigoPretencion]="getTagFileOtrosDocumentos(formOtrosDocumentos)"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_9)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_9).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_9)"
                    [paso]="listaPasosRoi.PASO_9"
                    [codigoPretencion]="getTagFileOtrosDocumentos(formOtrosDocumentos)"
                    [solicitante]="solicitante"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_9)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <h4 class="wrapper__form__content__subtitle">
                {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][10] }},
                {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][11] }} y
                {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][12] }}
              </h4>
            </div>
            <div class="mt-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_10).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_10)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_10"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_10)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_10).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_10)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_10"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (guardo)="subirArchivo($event)"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_10)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_11).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_11)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_11"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_11)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_11).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_11)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_11"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_11)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_12).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_12)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_12"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_12)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_12).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_12)"
                    [idTipoTramite]="tipoTramite"
                    [paso]="listaPasosRoi.PASO_12"
                    [solicitante]="solicitante"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_12)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <app-form
                [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][13]"
                [fields]="reorSociedadReporteBienesMobiliarios"
                (changedControl)="onSubmitSociedadReporteBienesMobiliarios($event)"
                [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <div class="mt-3" *ngIf="mostrarArchivosPaso10">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite
                      *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_13).length > 0"
                      [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_13)"
                      [paso]="listaPasosRoi.PASO_13"
                      [codigoPretencion]="pretencionesPaso10"
                      [solicitante]="solicitante"
                      [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoRoi"
                      [btnEnviar]="false"
                      [enviar]="enviarDocumentos"
                      (archivosObligatoriosPasos)="getFileRequeridos($event)"
                      (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_13)"
                      [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                    </app-cargue-archivos-tramite>
                    <app-cargue-archivos-tramite
                      *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_13).length == 0"
                      [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_13)"
                      [paso]="listaPasosRoi.PASO_13"
                      [codigoPretencion]="pretencionesPaso10"
                      [solicitante]="solicitante"
                      [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoRoi"
                      [btnEnviar]="false"
                      [enviar]="enviarDocumentos"
                      (archivosObligatoriosPasos)="getFileRequeridos($event)"
                      (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_13)"
                      [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                  (click)="onSubmitFormulario(false)"
                  [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button
                  type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinuePasoNueve($event)" [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance11" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección Documentos Adicionales-->
            <app-form [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][14]"
                      [fields]="reorSociedadDocumentosAdicionales"
                      (changedControl)="onSubmitSociedadDocumentosAdicionales($event)" [idEntidad]="entidadId"
                      [withSubmitButton]="false">
            </app-form>
            <div class="mt-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_14).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_14)"
                    [paso]="listaPasosRoi.PASO_14"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviarEntidad"
                    [nombreCortoTramite]="nombreTramite"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_14)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(listaPasosRoi.PASO_14).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(listaPasosRoi.PASO_14)"
                    [paso]="listaPasosRoi.PASO_14"
                    [idTipoTramite]="tipoTramite"
                    [idTramite]="idTramiteSsoRoi"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviarEntidad"
                    [nombreCortoTramite]="nombreTramite"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, listaPasosRoi.PASO_14)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="onSubmitFormulario(false)" [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button class="btn-govco fill-send-govco w-auto"
                        (click)="onContinueFinalizar($event)" 
                        [attr.aria-label]="roiText['botones-envio']['finalizar-enviar']">
                  {{ roiText['botones-envio']['finalizar-enviar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
